import Cookies from '../vendors/cookie.min';
import {annotate} from '../vendors/rough-notation.min';

export default function accessibilityWidget () {
    const el = document.querySelector('.accessibility-toolkit');
    const body = document.body;
    const breadcrumbs = document.querySelector('.breadcrumbs');
    const headings = document.querySelectorAll('h1, h2, h3, h4');
    const expires = 30; // Cookies expires in 30 days
    const cookies_prefix = 'accessibility_';
    const radio_prefix = 'accessibility_text_size-';
    const fontSizes = ['regular', 'larger', 'largest'];
    const sizes = {
        regular: 1,
        larger: 1.05,
        largest: 1.1
    };

    const setBreadcrumbsActive = () => {
        $(breadcrumbs).slideDown(() => {
            body.classList.add('enable-breadcrumbs');
            Cookies.set(cookies_prefix + 'breadcrumbs', true, {expires});
        });
    };
    const setBreadcrumbsInactive = () => {
        $(breadcrumbs).slideUp(() => {
            body.classList.remove('enable-breadcrumbs');
            Cookies.remove(cookies_prefix + 'breadcrumbs');
        });
    };
    const checkBreadcrumbsState = () => {
        if (Cookies.get(cookies_prefix + 'breadcrumbs') === 'true') {
            body.classList.add('enable-breadcrumbs');
        }
    };
    const checkGreyscaleMode = () => {
        if (Cookies.get(cookies_prefix + 'desaturate') === 'true') {
            body.classList.add('grayscale-mode');
        }
    };
    const checkContrastMode = () => {
        if (Cookies.get(cookies_prefix + 'contrast') === 'true') {
            body.classList.add('contrast-mode');
        }
    };
    const checkCursor = () => {
        if (Cookies.get(cookies_prefix + 'cursor') === 'true') {
            body.classList.add('custom-cursor');
        }
    };
    const checkTitlesHighlight = () => {
        if (Cookies.get(cookies_prefix + 'headings') === 'true') {
            body.classList.add('highlight-headings');
        }
    };
    const checkLinksHighlight = () => {
        if (Cookies.get(cookies_prefix + 'links') === 'true') {
            body.classList.add('highlight-links');
        }
    };
    const checkFontSize = () => {
        const fontSize = Cookies.get(cookies_prefix + 'font-size');

        if (sizes.hasOwnProperty(fontSize)) {
            document.documentElement.style.setProperty('--font-scale-factor', sizes[fontSize]);
            body.classList.add('fontSize-' + fontSize);

            // eslint-disable-next-line no-undef
            window.dispatchEvent(new Event('resize'));
        }
    };

    if (typeof (el) === 'undefined' && el === null) {
        return;
    }

    checkBreadcrumbsState();
    checkTitlesHighlight();
    checkLinksHighlight();
    checkGreyscaleMode();
    checkContrastMode();
    checkFontSize();
    checkCursor();

    const overlay = document.querySelector('.accessibility-toolkit-overlay');
    const button = el.querySelector('.widget-button a');
    const closeButton = el.querySelector('.widget-header .close-toolkit');
    const checkboxes = el.querySelectorAll('input[type="checkbox"]');
    const radios = el.querySelectorAll('input[name="text_size"]');

    const handleTextSize = (radio) => {
        const id = radio.id.replace(radio_prefix, '');
        const scaleFactor = sizes[id];
        const fontSize = id;

        if (scaleFactor && fontSize) {
            document.documentElement.style.setProperty('--font-scale-factor', scaleFactor);

            fontSizes.forEach((size) => {
                body.classList.toggle('fontSize-' + size, id === size);
            });

            Cookies.set(cookies_prefix + 'font-size', fontSize, { expires });

            // eslint-disable-next-line no-undef
            window.dispatchEvent(new Event('resize'));
        }
    };

    const handleCheckboxClick = (checkbox) => {
        const id = checkbox.name;

        // eslint-disable-next-line default-case
        switch (id) {
        case 'shortcut':

            break;
        case 'focus':

            break;
        case 'cursor':
            if (checkbox.checked) {
                body.classList.add('custom-cursor');
                Cookies.set(cookies_prefix + 'cursor', true, {expires});
            } else {
                body.classList.remove('custom-cursor');
                Cookies.remove(cookies_prefix + 'cursor');
            }
            break;
        case 'alt_text':

            break;
        case 'headings':
            if (checkbox.checked) {
                body.classList.add('highlight-headings');
                Cookies.set(cookies_prefix + 'headings', true, {expires});
            } else {
                body.classList.remove('highlight-headings');
                Cookies.remove(cookies_prefix + 'headings');
            }
            break;
        case 'links':
            if (checkbox.checked) {
                body.classList.add('highlight-links');
                Cookies.set(cookies_prefix + 'links', true, {expires});
            } else {
                body.classList.remove('highlight-links');
                Cookies.remove(cookies_prefix + 'links');
            }
            break;
        case 'contrast':
            if (checkbox.checked) {
                body.classList.add('contrast-mode');
                Cookies.set(cookies_prefix + 'contrast', true, {expires});
            } else {
                body.classList.remove('contrast-mode');
                Cookies.remove(cookies_prefix + 'contrast');
            }
            break;
        case 'desaturate':
            if (checkbox.checked) {
                body.classList.add('grayscale-mode');
                Cookies.set(cookies_prefix + 'desaturate', true, {expires});
            } else {
                body.classList.remove('grayscale-mode');
                Cookies.remove(cookies_prefix + 'desaturate');
            }
            break;
        case 'breadcrumbs':
            if (checkbox.checked) {
                setBreadcrumbsActive();
            } else {
                setBreadcrumbsInactive();
            }
            break;
        }

        if (checkbox.checked) {
            console.log(id + ' checked');
        } else {
            console.log(id + ' unchecked');
        }
    };

    button.addEventListener('click', e => {
        e.preventDefault();
        body.classList.add('accessibility-widget-active');
    });

    closeButton.addEventListener('click', e => {
        e.preventDefault();
        body.classList.remove('accessibility-widget-active');
    });

    overlay.addEventListener('click', () => {
        body.classList.remove('accessibility-widget-active');
    });

    if (!checkboxes.length) {
        return;
    }

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            handleCheckboxClick(checkbox);
        });
    });

    if (!radios.length) {
        return;
    }

    radios.forEach(radio => {
        radio.addEventListener('change', () => {
            handleTextSize(radio);
        });
    });
}
